const AudienceAccessTypes = Object.freeze({
  ALL: 'all',
  PASSWORD: 'password',
  SPECIFIC_CONTACTS: 'specificContacts',
  SSO: 'sso',
  SSO_WITH_SPECIFIC_CONTACTS: 'ssoWithSpecificContacts'
});
export default AudienceAccessTypes;